  var counters = document.querySelectorAll(".counter");
  var speed = 300; // The lower the slower

  // Options for the IntersectionObserver
  var options = {
    threshold: 0.5 // Trigger when the element is 50% visible
  };

  var observer = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        var counter = entry.target;
        var updateCount = () => {
          var target = +counter.getAttribute("data-count");
          var count = +counter.innerText;

          // Lower inc to slow and higher to fast
          var inc = target / speed;

          if (count < target) {
            counter.innerText = Math.ceil(count + inc);
            setTimeout(updateCount, 1);
          } else {
            counter.innerText = target;
          }
        };

        updateCount();

        // Stop observing the element once it has been counted
        observer.unobserve(counter);
      }
    });
  }, options);

  counters.forEach((counter) => {
    observer.observe(counter);
  });

//Disable Link

const links = document.querySelectorAll(".product-more-info.accordion a.collapse_title");


for (let i = 0; i < links.length; i++) {
  links[i].setAttribute("href", "#");
}


var myElement = document.querySelector(".bwp-widget-policy .row--banners");
if (myElement !== null) {

  myElement.classList.remove("bwp-load-slick-mobile");
}


